import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import Hyperlink from "../../../Shared/Link/Hyperlink";
import { MaxChildren } from "../MaxChildren/MaxChildren";
import { CustomOptionsIndicator } from "./CustomOptionsIndicator";
import { PrepareRootNodeNameForEdit } from "./PrepareRootNodeNameForEdit";
import * as styles from "./RootNodeName.css";
import { RootNodeNameText } from "./RootNodeNameText";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function DisplayNodeDetails({
    rootNode,
    state,
    setState,
}: {
    rootNode: IWorkflowNode;
    state: IRootNodeFormState;
    setState: React.Dispatch<React.SetStateAction<IRootNodeFormState>>;
}) {
    const displayStyle = GetDisplayStyle(state.newName);

    return (
        <div style={displayStyle}>
            <div className={GetNodeFillerBackgroundStyleClass()} />
            <Hyperlink
                whenClicked={() =>
                    PrepareRootNodeNameForEdit(
                        rootNode,
                        state.parentNode,
                        setState,
                        state
                    )
                }
                classes={styles.namespacing}
            >
                <RootNodeNameText name={state.newName} />
                <CustomOptionsIndicator {...{ state }} />
                <MaxChildren maxChildren={state.newMaxChildren} />
            </Hyperlink>
            <div className={GetNodeFillerBackgroundStyleClass()} />
        </div>
    );
}

function GetDisplayStyle(text: string) {
    const isLargeElement = text.split(`\n`).length > 2;

    const result = isLargeElement
        ? {
              display: `grid`,
              gridTemplateColumns: `1fr minmax(100px, 1024px) 1fr`,
          }
        : {};

    return result;
}

function GetNodeFillerBackgroundStyleClass() {
    const color1 = `rgba(0, 0, 0, 0.05)`;
    const color2 = `rgba(143, 127, 39, 0.05)`;
    const size = `30px`;

    const nodeFillerBackgroundStyleClass = StyleClass(`nodeFillerBackground`, {
        margin: `15px`,
        backgroundImage: `linear-gradient(135deg, ${color1} 25%, ${color2} 25%, ${color2} 50%, ${color1} 50%, ${color1} 75%, ${color2} 75%, ${color2} 100%)`,
        backgroundSize: `${size} ${size}`,
    });

    return nodeFillerBackgroundStyleClass;
}
